import { render, staticRenderFns } from "./StatusButton.vue?vue&type=template&id=4c84cbb0&"
import script from "./StatusButton.vue?vue&type=script&lang=js&"
export * from "./StatusButton.vue?vue&type=script&lang=js&"
import style0 from "./StatusButton.vue?vue&type=style&index=0&id=4c84cbb0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.10.0_css-loader@3.2.0_lodash@4.17.21_vue-template-compiler@2.7.15_webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports